import angular from "angular";
import { result } from "lodash";
import "../../../services/cart";
import events from "../../../services/events";

angular.module("folkeuni").component("searchHeroVoucher", {
  bindings: {},
  templateUrl:
    "/shop-dist/templates/search-hero-voucher.html?c=" + window.cacheBurst,
  transclude: true,
  controller: function (Product, Cart, $rootScope) {
    const $ctrl = this;

    $ctrl.voucherReset = function () {
      Cart.reset();
      $ctrl.voucher = null;
      sessionStorage.removeItem("voucherSeen");

      // Fjern keyAccounts fra URL'en
      const url = new URL(window.location.href);
      url.searchParams.delete("keyAccounts");
      window.location.href = url.pathname + url.search;
    };

    $ctrl.showVoucher = function () {
      if ($ctrl.voucher) {
        events.createModal({
          headline: $ctrl.voucher.name2,
          content: $ctrl.voucherContent(),
        });
        sessionStorage.setItem("voucherSeen", "true");
      }
    };

    $ctrl.voucherContent = function () {
      let output = [`<p>${$ctrl.voucher.description}</p>`];
      output = output.concat(
        $ctrl.voucher.areas.map((area) => {
          return `
              <a class="btn outlined" href="/${area.url}/program">
                Se hold fra ${area.name}
              </a>
              `;
        })
      );

      return output.join("");
    };

    $ctrl.$onInit = async () => {
      await Product.getKeyAccountContract().then(
        function (contractObj) {
          const voucherSeen = sessionStorage.getItem("voucherSeen");
          $ctrl.voucher = contractObj;

          if ($ctrl.voucher) {
            $ctrl.voucher.startFormatted = window.formatDates(
              $ctrl.voucher.registrationStart
            );
            $ctrl.voucher.endFormatted = $ctrl.voucher.endFormatted
              ? window.formatDates($ctrl.voucher.registrationEnd)
              : false;

            if (!voucherSeen) {
              $ctrl.showVoucher();
            }
          }
        },
        function (errorResponse) {}
      );
    };
  },
});
